import { queryCludo, QueryCludoRequestInterface } from '3-foundation/Search/connector';
import logger from '3-foundation/Logging/logger';

export const defaultDocumentsLimit = 12;

export const getDocuments = async ({
	filters,
	limit,
	locale,
	siteId,
}: QueryCludoRequestInterface): Promise<{
	documents: Content.DocumentCatalogPageProperties['documents'];
	facets: Content.DocumentCatalogPageProperties['facets'];
	totalDocuments: Content.DocumentCatalogPageProperties['totalDocuments'];
}> => {
	try {
		const searchResult = await queryCludo({
			filters: { ...filters, pageType: 'documentPage' },
			limit: limit ? limit : defaultDocumentsLimit,
			sort: { 'search-sort': 'desc' },
			locale,
			siteId,
		});
		const { TypedDocuments: items, Facets, TotalDocument } = searchResult ?? {};

		const documents = items?.map((item) => {
			return {
				title: item.Fields.Title.Value,
				date: item.Fields['search-date'].Value || null,
				image: {
					url: item.Fields['search-image-url']?.Value || null,
					altText: '',
				},
				teaser: item.Fields['search-teaser']?.Value || null,
				link: {
					name: '',
					url: item.Fields.Url.Value,
				},
			};
		});

		const mapFacets = (facets) => {
			return facets
				?.map((tag) => {
					return { name: tag.Key, count: tag.Count };
				})
				.filter((tag) => tag.name !== 'Other');
		};

		const facets = {
			subject: mapFacets(Facets?.Category?.Items),
			status: mapFacets(Facets?.['search-tags-status']?.Items),
			type: mapFacets(Facets?.['search-tags-type']?.Items),
			date: mapFacets(Facets?.['search-date-year-month']?.Items),
		};

		return { documents, facets, totalDocuments: TotalDocument };
	} catch (e) {
		logger.error(`Document Repository failed to deliver data. \nCause: ${e.message}`, e);
		throw new Error(`Document Repository failed to deliver data. \nCause: ${e.message}`, e);
	}
};
